const SENSITIVE_KEYS = /token|password|authorization|secret|credential/i

const sanitize = (value, seen = new WeakSet()) => {
  if (!value || typeof value !== 'object') return value
  if (seen.has(value)) return '[Circular]'
  seen.add(value)

  if (Array.isArray(value)) return value.map((item) => sanitize(item, seen))

  return Object.entries(value).reduce((result, [key, item]) => {
    result[key] = SENSITIVE_KEYS.test(key) ? '[REDACTED]' : sanitize(item, seen)
    return result
  }, {})
}

const emit = (level, event, details) => {
  if (process.env.NODE_ENV === 'production' && level === 'info') return
  const payload = details === undefined ? undefined : sanitize(details)
  console[level](`[KAMS] ${event}`, payload)
}

export const logger = {
  error: (event, details) => emit('error', event, details),
  warn: (event, details) => emit('warn', event, details),
  info: (event, details) => emit('info', event, details),
}
